var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "AddressPconment" },
    [
      _c(
        "van-cell-group",
        [
          _c("van-cell", {
            attrs: { title: "热力公司", "is-link": "", value: _vm.district },
            on: { click: _vm.onCompany }
          }),
          _vm._v(" "),
          _c("van-cell", {
            attrs: {
              title: "小区",
              "is-link": "",
              value: _vm.villageData.villageName
            },
            on: { click: _vm.onVillage }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        [
          _c("van-cell", {
            attrs: {
              title: "楼栋",
              "is-link": "",
              value: _vm.buildingData.buildingName
            },
            on: { click: _vm.onBuilding }
          }),
          _vm._v(" "),
          _c("van-cell", {
            attrs: {
              title: "单元",
              "is-link": "",
              value: _vm.unit ? _vm.unit : "请选择单元"
            },
            on: { click: _vm.onUnit }
          }),
          _vm._v(" "),
          _c("van-cell", {
            attrs: {
              title: "楼层",
              "is-link": "",
              value: _vm.floorNo ? _vm.floorNo : "请选择楼层"
            },
            on: { click: _vm.onFloor }
          }),
          _vm._v(" "),
          _c("van-cell", {
            attrs: {
              title: "室号",
              "is-link": "",
              value: _vm.roomNo ? _vm.roomNo : "请选择室号"
            },
            on: { click: _vm.onRoom }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        [
          _c("van-cell", {
            attrs: {
              title: "分组",
              "is-link": "",
              value: _vm.TagValue ? _vm.TagValue : "请选择分组"
            },
            on: { click: _vm.onTag }
          }),
          _vm._v(" "),
          _c(
            "van-cell",
            { attrs: { title: "设为默认" } },
            [
              _c("van-switch", {
                attrs: {
                  value: _vm.checked,
                  "active-color": "#07c160",
                  "inactive-color": "#dadee1"
                },
                on: { input: _vm.onDefaultFlag }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-col",
        {
          staticClass: "barBtn",
          attrs: { span: "24", type: "flex", justify: "space-between" }
        },
        [
          _c(
            "van-button",
            {
              staticClass: "saveBth",
              attrs: {
                round: "",
                type: "danger",
                size: "large",
                disabled: _vm.isSave
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.UpdateInfo($event)
                }
              }
            },
            [_vm._v("保存")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.isShow,
            callback: function($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow"
          }
        },
        [
          _c("van-picker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isCompany,
                expression: "isCompany"
              }
            ],
            attrs: {
              "show-toolbar": "",
              columns: _vm.columns,
              "value-key": "companyName"
            },
            on: {
              confirm: _vm.onCompanyConfirm,
              cancel: function($event) {
                _vm.isShow = false
              }
            }
          }),
          _vm._v(" "),
          _c("van-picker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isUFRpop,
                expression: "isUFRpop"
              }
            ],
            attrs: {
              "show-toolbar": "",
              columns: _vm.BUFRinfo,
              "value-key": _vm.infoKey
            },
            on: {
              confirm: _vm.onUFRConfirm,
              cancel: function($event) {
                _vm.isShow = false
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.villageList
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isVillage,
                  expression: "isVillage"
                }
              ],
              staticClass: "popCon"
            },
            [
              _c(
                "div",
                { staticClass: "returnBtn" },
                [
                  _c(
                    "van-button",
                    {
                      attrs: { icon: "arrow-left", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.isVillage = false
                        }
                      }
                    },
                    [_vm._v("返回")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-index-bar",
                { attrs: { "index-list": _vm.indexList, sticky: "" } },
                _vm._l(_vm.indexList, function(index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("van-index-anchor", { attrs: { index: index } }),
                      _vm._v(" "),
                      _vm._l(_vm.villageList, function(item) {
                        return _c(
                          "div",
                          [
                            item.villageNameS == index
                              ? _c("van-cell", {
                                  attrs: { title: item.villageName },
                                  on: {
                                    click: function($event) {
                                      return _vm.VillageSelect(
                                        item.villageId,
                                        item.villageName
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tagBox",
          style: { height: "20%" },
          attrs: { position: "bottom" },
          model: {
            value: _vm.isTagShow,
            callback: function($$v) {
              _vm.isTagShow = $$v
            },
            expression: "isTagShow"
          }
        },
        [
          _c(
            "van-swipe",
            {
              staticClass: "tagBar",
              attrs: { loop: false, width: 100, "show-indicators": false }
            },
            _vm._l(_vm.Taglist, function(item, index) {
              return _c(
                "van-swipe-item",
                {
                  key: index,
                  on: {
                    click: function($event) {
                      return _vm.TagChange(item)
                    }
                  }
                },
                [_vm._v(_vm._s(item))]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bafa14e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bafa14e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AddressManage/addAddress.vue
// module id = null
// module chunks = 